// components/TrainingTabs.js
import React, { useState, useMemo } from "react";

export default function TrainingTabs({ tabs }) {
  // first tab key, stable even if tabs object changes order
  const firstKey = useMemo(() => Object.keys(tabs)[0], [tabs]);
  const [activeKey, setActiveKey] = useState(firstKey);

  const entries = Object.entries(tabs);

  return (
    <>
      <div className="tab-bar">
        {entries.map(([key, { label }]) => (
          <button
            key={key}
            className={`tab-btn ${key === activeKey ? "active" : ""}`}
            onClick={() => setActiveKey(key)}
          >
            {label}
          </button>
        ))}
      </div>

      {/* KEEP ALL PANES MOUNTED; hide the inactive one */}
      <div className="tab-content">
        {entries.map(([key, { content }]) => (
          <div
            key={key}
            style={{ display: key === activeKey ? "block" : "none" }}
          >
            {content}
          </div>
        ))}
      </div>
    </>
  );
}
